import axios from '@/axios-mock'

module.exports = {
  login: (data) => {
    return axios({
      url: `/app/authentication`,
      method: 'POST',
      json: data
    })
  },
  sms: (phone, captcha, type = 'VERIFY_CODE') => {
    return axios({
      url: `/app/sms`,
      method: 'POST',
      json: {
        'phone': phone,
        'captcha': captcha,
        'type': type
      }
    })
  },
  checkVerifiedMobile: (phone) => {
    return axios({
      url: `/app/member/checkVerifiedMobile`,
      method: 'PUT',
      json: phone
    })
  },
  verifiedMobile: (phone, captcha, password) => {
    var data ={
      "verifiedMobile": phone
    }
    if(password){
      data.password = password
    }
    return axios({
      url: `/app/member/verifiedMobile?captcha=${captcha}`,
      method: 'PUT',
      json: data
    })
  },
  register: (phone, password, captcha) => {
    return axios({
      url: `/app/register?captcha=${captcha}`,
      method: 'POST',
      json: {
        'principal': phone,
        'credential': password
      }
    })
  },
  merge: (id) => {
    return axios({
      url: `/app/member/merge?id=${id}`,
      method: 'POST',
      json: {}
    })
  },
  modification: (phone, password, captcha) => {
    return axios({
      url: `/app/key/modification`,
      method: 'POST',
      json: {
        'principal': phone,
        'from': captcha,
        'to': password
      }
    })
  }
}



// WEBPACK FOOTER //
// ./static/components/app-login/api.js